import {
  ChangeDetectorRef,
  Component, EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit, Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, Subject } from 'rxjs';
import { InlineSvgComponent } from '../../../../components/inline-svg/inline-svg.component';
import { Bookmark } from '../../../../models/bookmark.model';
import { CreateBookmarkModalComponent } from './create-bookmark-modal/create-bookmark-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Project } from '../../../../models/project.module';
// import { MapCommunicatorService } from '../../map-communicator.service';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { NgClass } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatFormField, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { Selectedlayer } from '../../../../models/layer.models';
import { BookmarkService } from '../../../../services/bookmark.service';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { ConfirmationDialogComponent } from '../../../../components/confirmation-dialog/confirmation-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastNotificationService } from '../../../../services/toast-notification.service';
import { User } from '../../../../models/user.model';
import { MapCommunicatorService } from '../../map-communicator.service';
import { LayerService } from '../../../../services/layer.service';
import { Router } from '@angular/router';

@Component({
  selector: 'frmg-bookmarks-sidebar',
  templateUrl: './bookmarks-sidebar.component.html',
  styleUrls: ['./bookmarks-sidebar.component.scss'],
  imports: [ReactiveFormsModule, FormsModule, InlineSvgComponent, MatTooltip, MatMenu, MatMenuItem, MatMenuTrigger, NgClass, MatFormField, MatInput, MatPrefix, MatSuffix, MatCheckbox]
})
export class BookmarksSidebarComponent implements OnInit, OnDestroy, OnChanges {
  @Input() mapCommunicator!: Subject<string>;
  @ViewChild('orderTrigger') orderTrigger: MatMenuTrigger;

  public searchBookmarkCtrl: FormControl;
  public bookmarks: Array<Bookmark> = [];
  public activeTab = 'my';
  public sortState = 'created_at:desc';
  public searchActive: boolean = false;
  public selectAll: boolean = false;
  public isLoading: boolean = false;
  public folder: Project;
  public currentUser: User;
  private destroy$ = new Subject<void>();
  public excludeSelectedArray = new Set<string>();
  public includeSelectedArray = new Set<string>();
  public total: number = 0;
  @Input() currentProject!: Project;
  @Input() layersState!: Selectedlayer[];
  @Input() bbox!: number[];
  @Output() onActivate = new EventEmitter<Bookmark>();


  constructor(
    private dialog: MatDialog,
    private bookmarkService: BookmarkService,
    private layerService: LayerService,
    private toastNotificationService: ToastNotificationService,
    private mapCommunicatorService: MapCommunicatorService,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private router: Router
  ) {
    this.searchBookmarkCtrl = this.fb.control('');
    this.currentUser = JSON.parse(localStorage.getItem('user')) as User;
    this.mapCommunicatorService.mapCommunicator.subscribe(action => {
      if (action === 'saveBookmark') {
        this.getBookmarks();
      }
    });
    this.searchBookmarkCtrl.valueChanges.pipe(debounceTime(500)).subscribe(_ => {
      this.getBookmarks();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['bbox']) {
      this.bbox = changes['bbox'].currentValue;
    }
    if (changes['currentProject']) {
      this.currentProject = changes['currentProject'].currentValue;
      this.getBookmarks();
    }
    if (changes['layersState']) {
      this.layersState = changes['layersState'].currentValue;
    }
  }

  ngOnInit() {
    this.getBookmarks();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public isFolderDirrectProjectChild(folder: Project) {
    return folder?.path?.split('/').length <= 2;
  }

  public isSelected(bookmark: Bookmark) {
    const id = bookmark.id;
    return this.selectAll
      ? !this.excludeSelectedArray.has(id)
      : this.includeSelectedArray.has(id);
  }

  public someChecked(): boolean {
    return this.selectAll
      ? !!this.excludeSelectedArray.size
      : !!this.includeSelectedArray.size;
  }

  public setAll(all: boolean): void {
    this.selectAll = all;
    this.includeSelectedArray.clear();
    this.excludeSelectedArray.clear();
  }

  public bookmarkChecked(bookmark: Bookmark, event?: Event | MatCheckboxChange) {
    if (event && (event as any).stopPropagation) {
      (event as any).stopPropagation();
    }

    const id = bookmark.id;
    if (this.selectAll) {
      if (this.excludeSelectedArray.has(id)) {
        this.excludeSelectedArray.delete(id);
      } else {
        this.excludeSelectedArray.add(id);
      }
    } else {
      if (this.includeSelectedArray.has(id)) {
        this.includeSelectedArray.delete(id);
      } else {
        this.includeSelectedArray.add(id);
      }
    }
  }

  public getCheckedAmount() {
    return this.selectAll ? this.total - this.excludeSelectedArray.size : this.includeSelectedArray.size;
  }

  public createNew() {
    const createModal = this.dialog.open(CreateBookmarkModalComponent, {
      data: {
        project: this.currentProject,
        layers: this.layersState,
        bbox: this.bbox
      }
    });

    createModal.afterClosed().subscribe(resp => {
      if (resp)  {
        this.getBookmarks();
      }
    });
  }

  public bulkDelete(bookmark? : Bookmark, bookmarkMenuTrigger?: MatMenuTrigger) {
    bookmarkMenuTrigger.closeMenu();
    this.dialog
      .open<ConfirmationDialogComponent>(ConfirmationDialogComponent, {
        data: {
          header: `Are you sure you want to delete ${bookmark ? 'this bookmark' : 'these bookmarks'}?`,
          body: `${bookmark ? 'It' : 'They'} will be removed for all users and won’t be available anymore.`,
          confirmText: 'Delete'
        }
      }).afterClosed().subscribe(resp => {
        const filter = {
          filters: ''
        };
        // const rolePrefix = this.activeTab === 'my' ? `,user_id:eq:${this.currentUser.id}` : `,user_id:ne:${this.currentUser.id}`;
        if (bookmark)  {
          filter.filters = `id:eq:${bookmark.id}`;
        } else if (this.selectAll) {
          filter.filters = 'id:isnot:null';
        } else if (this.excludeSelectedArray.size > 0) {
          filter.filters = `id:not_in:${Array.from(this.excludeSelectedArray).join('|')}`;
        } else if (this.includeSelectedArray.size > 0) {
          filter.filters = `id:in:${Array.from(this.includeSelectedArray).join('|')}`;
        }
        if (resp) this.bookmarkService.deleteBookmark(filter).subscribe(_ => {
          this.setAll(false);
          this.getBookmarks();
          this.toastNotificationService.showNotification({ message: 'Bookmark deleted successfully.', type: 'success' });
        }, (error: HttpErrorResponse) => {
          this.toastNotificationService.showNotification({ message: error.error.detail, type: 'error' });
        });
      });
  }

  public activateBookmark(bookmark: Bookmark) {
    this.mapCommunicatorService.mapCommunicator.next(`activateBookmark_${ bookmark.bbox.join('|')}`);
    const layers_data = bookmark.bookmark_metadata['layers_data'];
    // this.mapCommunicatorService.currentProject.next(bookmark.bookmark_metadata['folder']);
    if (bookmark.visible_layers.length > 0 && layers_data) {
      this.mapCommunicatorService.layers.next(layers_data);
      const layersForm = {};
      layers_data.forEach(layer => {
        layersForm[layer.layer.layer.name] = layer;
      });
      this.layerService.setSavedLayers(layersForm);
    } else  {
      this.mapCommunicatorService.mapCommunicator.next('clear_layers');
    }
    this.router.navigate([`/risk-map/${bookmark.bookmark_metadata['folder'].path}`], {});
    // after map move end
    setTimeout(_ => {
      this.onActivate.emit(bookmark);
    }, 500);
  }

  public editBookmark(bookmark: Bookmark, event: Event, bookmarkMenuTrigger: MatMenuTrigger) {
    if (event && (event as any).stopPropagation) {
      (event as any).stopPropagation();
    }
    bookmarkMenuTrigger.closeMenu();
    const createModal = this.dialog.open(CreateBookmarkModalComponent, {
      data: {
        bookmark
      }
    });

    createModal.afterClosed().subscribe(resp => {
      if (resp)  {
        this.bookmarks.find(bkmk => bkmk.id === bookmark.id).name = resp.name;
        this.cd.detectChanges();
      }
    });
  }

  public getActiveTab(tab: string) {
    if (tab === this.activeTab) return ;
    this.total = 0;
    this.activeTab = tab;
    this.setAll(false);
    this.getBookmarks();
  }

  public updateSortState(state: string) {
    this.sortState = state;
    this.getBookmarks();
  }

  public getBookmarks(add?: boolean) {
    this.isLoading = true;
    if (!add) this.bookmarks = [];
    this.cd.detectChanges();
    const query = this.searchBookmarkCtrl.value;
    const userFilterOp = this.activeTab === 'my' ? 'eq' : 'ne';
    const queryKeys = {
      sorts: this.sortState,
      filters: `name:ilike:${query}%,user.email:${userFilterOp}:${this.currentUser.email}`,
      skip: add ? this.bookmarks.length : 0,
      limit: 25
    };
    this.bookmarkService.getAllBookmarks(queryKeys).subscribe(resp => {
      this.total = resp.total;
      if (add) {
        this.bookmarks = [...this.bookmarks, ...resp.items];
      } else {
        this.bookmarks = resp.items;
      }
      this.isLoading = false;
      this.cd.detectChanges();
    });
  }

  public toggleSearch() {
    this.searchActive = true;
  }

  public clearSearch() {
    if (this.searchBookmarkCtrl.value !== '') {
      this.searchBookmarkCtrl.setValue('');
    } else {
      this.searchActive = false;
    }
  }

  onScroll(event: Event) {
    if (this.isLoading) return;
    const target = event.target as HTMLElement;

    const scrollPosition = target.scrollTop + target.clientHeight;
    const threshold = target.scrollHeight - 200;

    if (scrollPosition >= threshold && this.bookmarks.length < this.total) {
      this.getBookmarks(true);
    }
  }
}
